<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">Transfer Notification</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
</div>

<div class="modal-body">
  <form autocomplete="off">

    <div class="mb-3" *ngIf="users.length">
      <label class="form-label fw-semibold">User</label>
      <ng-select
        [items]="users"
        bindLabel="name"
        placeholder="Search user..."
        [(ngModel)]="selectedUser"
        [ngModelOptions]="{standalone: true}"
        (change)="selectionUpdated()">
      </ng-select>
    </div>

  </form>
</div>

<div class="modal-footer">
  <ng-container *ngIf="!isLoading">
    <button type="button" class="btn btn-success" [disabled]="invalidSelection" (click)="transferNotifications()">OK</button>
  </ng-container>

  <button *ngIf="isLoading" type="button" class="btn btn-success" disabled>
    <span class="spinner-border spinner-border-sm" role="status"></span>
    Loading...
  </button>
</div>